import React, { useState } from 'react';
import axios from 'axios';
import { FormControl, TextField } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import styles from './styles.module.scss';

function Form(props) {
	const [name, setName] = useState('');
	const [email, setEmail] = useState('');
	const [msg, setMsg] = useState('');
	const [text, setText] = useState('');

	const useStyles = makeStyles((theme) => ({
		label: {
			'&$focused': {
				color: '#cd0305',
				fontSize: '17px',
				fontWeight: 'bold',
			},
		},
		focused: {},
		outlinedInput: {
			'&$focused $notchedOutline': {
				border: '2px solid #cd0305',
			},
		},
		notchedOutline: {},
	}));

	const classes = useStyles();

	const handleSubmit = async () => {
		var tmp;
		if (process.env.NODE_ENV === 'production')
			tmp = 'https://sarah23sserver.herokuapp.com';
		else tmp = `http://localhost:5000`;

		try {
			const data = {
				name,
				email,
				message: msg,
				type:
					props.type === 'Book' ? 'Book recommendation' : 'Getting in touch',
			};

			axios.post(`${tmp}/sendMail`, data).then((response) => {
				if (response.data.data) {
					setText(`Mail sent successfully, thank you for ${props.success}! <3`);
					setName('');
					setMsg('');
					setEmail('');
				} else setText('Sorry, an error occurred, please try again later :(');
			});
		} catch (err) {
			console.log('~error: ', err);
		}
	};

	return (
		<div
			className={`${styles.formGroup} ${
				props.type === 'Book' ? styles.bookForm : null
			}`}
		>
			<FormControl className={styles.formControl}>
				<TextField
					className='textField'
					label='Name'
					multiline
					rows={1}
					variant='outlined'
					value={name}
					onChange={(event) => setName(event.target.value)}
					InputLabelProps={{
						classes: {
							root: classes.label,
							focused: classes.focused,
						},
					}}
					InputProps={{
						classes: {
							root: classes.outlinedInput,
							focused: classes.focused,
							notchedOutline: classes.notchedOutline,
						},
					}}
				/>
			</FormControl>

			<FormControl className={styles.formControl}>
				<TextField
					className='textField'
					label={props.type}
					multiline
					rows={1}
					variant='outlined'
					value={email}
					onChange={(event) => setEmail(event.target.value)}
					InputLabelProps={{
						classes: {
							root: classes.label,
							focused: classes.focused,
						},
					}}
					InputProps={{
						classes: {
							root: classes.outlinedInput,
							focused: classes.focused,
							notchedOutline: classes.notchedOutline,
						},
					}}
				/>
			</FormControl>

			<FormControl className={styles.formControl}>
				<TextField
					className='textField'
					label={props.message}
					multiline
					rows={4}
					variant='outlined'
					value={msg}
					onChange={(event) => setMsg(event.target.value)}
					InputLabelProps={{
						classes: {
							root: classes.label,
							focused: classes.focused,
						},
					}}
					InputProps={{
						classes: {
							root: classes.outlinedInput,
							focused: classes.focused,
							notchedOutline: classes.notchedOutline,
						},
					}}
				/>
			</FormControl>

			<p className={`${styles.helperText}`}>{text}</p>
			<button className={styles.formBtn} onClick={handleSubmit}>
				{props.button}
			</button>
			{/* {props.children} */}
			{props.type === 'Book' ? (
				<button
					className={`${styles.formBtn} ${styles.closeBtn}`}
					onClick={() => props.setShowForm(false)}
				>
					Close :(
				</button>
			) : null}
		</div>
	);
}
export default Form;
